import { ReportDocument } from "./ReportDocument";

export interface PagedData<T> {
  result: T;
  pageCount: number;
  totalCount: number;
}

export const EMPTY_PAGED_REPORTS: PagedData<ReportDocument[]> = {
  pageCount: 0,
  totalCount: 0,
  result: [],
};
